import { endOfMonth, endOfYear, startOfMonth, startOfYear, sub } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { DateRangeItem } from '~/types/date';
import { formatDateForDisplay } from '~/utils/formatDate';

export const useDefaultRanges = (date: Date, allowFuture?: boolean): DateRangeItem[] => {
  const { t } = useTranslation('inputs', { keyPrefix: 'date_range_filters' });
  return [
    {
      startDate: startOfMonth(date),
      endDate: endOfMonth(date),
      sublabel: allowFuture ? undefined : t('from_until_today', { date: formatDateForDisplay(startOfMonth(date)) }),
    }, // until current month
    { startDate: startOfMonth(sub(date, { months: 1 })), endDate: endOfMonth(sub(date, { months: 1 })) }, // last month
    { startDate: startOfMonth(sub(date, { months: 2 })), endDate: endOfMonth(sub(date, { months: 2 })) }, // two months ago
    {
      startDate: startOfYear(date),
      endDate: endOfYear(date),
      sublabel: allowFuture ? undefined : t('from_until_today', { date: formatDateForDisplay(startOfYear(date)) }),
    }, // current year
    { startDate: startOfYear(sub(date, { years: 1 })), endDate: endOfYear(sub(date, { years: 1 })) }, // last year
    { startDate: startOfYear(sub(date, { years: 2 })), endDate: endOfYear(sub(date, { years: 2 })) }, // two years ago
  ];
};
